import React, { useState, useContext } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import styles from './styles.css';
import { CartContext } from '../../context/CartContext/CartContext';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import {
  dollarMask,
  removeCommasAndParseFloat,
  withDefault
} from '../../core/util';
import {
  addCommas,
  handleInputFormat,
  isNonFundedFlow
} from '../../flows/shared/utils';

const InvestmentAmount = ({ displayAmount }) => (
  <>
    <span className="displayamount-bold">${displayAmount}.00.</span>
    <style jsx>{styles}</style>
  </>
);

export default ({ accountType }) => {
  const {
    totalAmount,
    api: { changeTotalAmount }
  } = useContext(CartContext);
  const [editAmount, setEditAmount] = useState(false);
  const [displayAmount, setDisplayAmount] = useState(dollarMask(totalAmount));
  const [amountValue, setAmountValue] = useState('');

  const handleChange = ({ target: { value } }) => {
    const formattedValue = addCommas(value);
    setDisplayAmount(formattedValue);
  };

  const editContributionAmount = () => {
    const formattedValue = addCommas(
      (displayAmount.length && displayAmount) || '0'
    );
    changeTotalAmount(removeCommasAndParseFloat(formattedValue));
    setEditAmount(!editAmount);
  };

  const nonFundedSubHeaderText = `Select one or more mutual funds from the list below for your investments of:`;
  const rollTranSubheaderText = `Select one or more mutual funds from the list below in which to invest your`;

  const subHeaderText = isNonFundedFlow(accountType)
    ? nonFundedSubHeaderText
    : rollTranSubheaderText;

  return (
    <>
      <div className="allocation-input-container">
        {!editAmount && (
          <span className="select-investments-sub">
            {subHeaderText}
            <span className="total-contri">
              <InvestmentAmount displayAmount={displayAmount} />
              <span className="edit-total-contri-btn">
                <MFBeaconButton
                  id="editAmountBYOPToggleBtn"
                  data-name="editAmountBYOPToggleBtn"
                  onClick={() => setEditAmount(!editAmount)}
                  variant="tertiary"
                  label="Edit Amount"
                />
              </span>
            </span>
          </span>
        )}
        {editAmount && (
          <div className="select-investments-sub-edit">
            {subHeaderText}
            <div className="select-investments-input-view">
              <div className="total-amount-input-field">
                <InputField
                  maxLength="12"
                  name="amount"
                  onChange={evt => {
                    handleChange(evt);
                    handleInputFormat(evt, 'LOCALE_STRING', setAmountValue);
                  }}
                  value={withDefault(amountValue, displayAmount)}
                />
              </div>
              <span className="update-amount-btn">
                <MFBeaconButton
                  className="continue-btn"
                  variant="primary"
                  size="normal"
                  id="updateAmountBYOP"
                  data-name="updateAmountBYOP"
                  onClick={editContributionAmount}
                  label="Update"
                />
              </span>
            </div>
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};
